import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  Divider,
  Typography,
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Tv as TvIcon,
  Image as MediaIcon,
  Restaurant as MenuIcon,
  Settings as SettingsIcon,
  Handshake as WelcomeIcon,
} from '@mui/icons-material';
import { RiPlanetFill, RiArtboardLine, RiFolderCloudLine, RiComputerLine, RiPlanetLine, RiComputerFill, RiFolderCloudFill, RiArtboardFill } from '@remixicon/react';
import Logo from '../assets/images/digilogo-b.svg';

const drawerWidth = 240;

const menuItems = [
  { text: 'Welcome', iconActive: <RiPlanetFill />, icon: <RiPlanetLine />, path: '/' },
  { text: 'TV Management', iconActive: <RiComputerFill />, icon: <RiComputerLine />, path: '/tvs' },
  { text: 'Media', iconActive: <RiFolderCloudFill />, icon: <RiFolderCloudLine />, path: '/media' },
  { text: 'Canvas', iconActive: <RiArtboardFill />, icon: <RiArtboardLine />, path: '/menus' },
];

const Sidebar = ({ open, onClose, variant = 'permanent' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    if (variant === 'temporary') {
      onClose();
    }
  };

  const drawerContent = (
    <Box sx={{ overflow: 'auto', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 3, display: { xs: 'none', md: 'block' } }}>
        {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              backgroundColor: 'primary.main',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 800,
              fontSize: 20,
            }}
          >
            S
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight={700}>
              Digi
            </Typography>
            <Typography variant="subtitle1" fontWeight={700} sx={{ mt: -0.5 }}>
              Solutions
            </Typography>
          </Box>
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          Don't Say It, Display It!
        </Typography> */}
        <Box sx={{  textAlign: 'center' }}>
          <img src={Logo} alt="Logo" />
        </Box>
      </Box>

      {/* <Divider sx={{ display: { xs: 'none', md: 'block' } }} /> */}

      <List sx={{ flexGrow: 1, pt: 2 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => handleNavigation(item.path)}
              sx={{
                mx: 1,
                borderRadius: 1,
                '&.Mui-selected': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  },
                  '& .MuiListItemIcon-root': {
                    color: 'white',
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: location.pathname === item.path ? 'white' : 'text.secondary',
                }}
              >
                {location.pathname === item.path ? item.iconActive : item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {/* Desktop Drawer */}
      <Drawer
        variant={variant}
        open={open}
        onClose={onClose}
        sx={{
          display: { xs: 'none', md: 'block' },
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            borderRight: '1px solid',
            borderColor: 'divider',
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
};

export default Sidebar;

